export default function createLatLngBounds(bounds) {
    function boundsMissing() {
        return !bounds.north || !bounds.east || !bounds.south || !bounds.west;
    }

    if (boundsMissing()) {
        throw new TypeError('No bounds provided.');
    }

    return {
        getNorthEast: function getNorthEast() {
            return {
                lat: function lat() { return parseFloat(bounds.north); },
                lng: function lng() { return parseFloat(bounds.east); },
            };
        },
        getSouthWest: function getSouthWest() {
            return {
                lat: function lat() { return parseFloat(bounds.south); },
                lng: function lng() { return parseFloat(bounds.west); },
            };
        },
        /** Jer Google Maps API ne trpi (?) nikakve dodatne parametre kao što su getNorthEast i getSouthWest */
        getGoogleLiteral: function getGoogleLiteral() {
            return {
                north: parseFloat(bounds.north),
                east: parseFloat(bounds.east),
                south: parseFloat(bounds.south),
                west: parseFloat(bounds.west),
            };
        },
    };
}
